<template>
  <div class="svg-icon-container" @click="onClick" v-html="svgData" />
</template>

<script>
import iconMetadata from '../../vuex/icon-metadata.js';
import requests from '../../vuex/requests.js';
import { has } from '../../utils.js';

export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: '0',
    },
    height: {
      type: String,
      default: '0',
    },
    fill: {
      type: String,
      default: '#BCBCBC',
    },
    svgFill: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      svgData: null,
      domParser: null,
    };
  },

  watch: {
    async icon(newValue, oldValue) {
      await this.loadSvg();
    },

    async fill(newValue, oldValue) {
      await this.loadSvg();
    },
  },

  async mounted() {
    await this.loadSvg();
  },

  methods: {
    /**
     * Set the svg data and add width, height and fill attributes
     */
    async loadSvg() {
      const svg = await this.getSvgIcon(this.icon);
      const fill = this.svgFill ? null : this.fill;
      this.svgData = this.setAttributes(svg, this.width, this.height, fill);
      this.$emit('onLoad', this.svgData);
    },

    /**
     * Retrieve the data of an svg icon either from web or from the cache
     * @param   {string}  icon   The icon to load
     * @return  {string}         The svg data
     */
    async getSvgIcon(icon) {
      this.loadSpinner();
      // Get the icon and cache it
      await iconMetadata.getIcons([icon]);
      return iconMetadata.getCache(icon);
    },

    /**
     * Sets the attributes of an svg icon (in string format)
     * @param   {string}       svg     The svg data in string format
     * @param   {Number}       width   The desired width
     * @param   {Number}       height  The desired height
     * @param   {string|null}  fill    The desired color (null for default)
     * @returns {string}               The svg data in string format modified
     */
    setAttributes(svg, width, height, fill = null) {
      // We will parse the svg string
      this.domParser = this.domParser || new DOMParser();
      const doc = this.domParser.parseFromString(svg, 'image/svg+xml');
      // The result is an SVGDocument for this MIME type
      doc.rootElement.setAttribute('width', width);
      doc.rootElement.setAttribute('height', height);

      // Set the fill color
      if (fill) {
        const nodes = Array.from(doc.querySelectorAll('path'));
        nodes.forEach(node => {
          node.setAttribute('fill', fill);
        });
      }

      return doc.rootElement.outerHTML;
    },

    /**
     * Set the spinner icon as the svg icon
     */
    loadSpinner() {
      // The spinner should already be cached
      const svg = iconMetadata.getCache('app-icons/spinner');
      this.svgData = this.setAttributes(svg, this.width, this.height, null);
    },

    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>
<style scoped lang="scss">
.svg-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
